import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import { CustomLogoApp } from "../components/logo";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { App_sesion_token_key, AxiosInstance, DialogType, LocaleYupValidation } from "../utils/constants";
import { useContext, useEffect } from "react";
import { ActionTypes, AppContext } from "../store/AppStore";
import { useNavigate } from "react-router-dom";
import { AppERoutesIndex } from "../route/app-routes";

yup.setLocale(LocaleYupValidation);
const loginSchema = yup.object({
    usuario: yup.string().email().required(),
    clave: yup.string().required(),
  }).required();

export const Login = ()=>{

    const { register, handleSubmit, formState:{ errors } } = useForm({
        resolver: yupResolver(loginSchema)
      });
      const {dispatch} = useContext( AppContext );
    const navigate = useNavigate();  


    const onSumitData = (payload)=>{
        dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
        });
        AxiosInstance.post("sesion/iniciar-sesion",payload).then(({data})=>{
            
            if ( data.status ){
                localStorage.setItem(App_sesion_token_key,data.value.sesion_token);
                navigate(AppERoutesIndex.main);
            }else{
                dispatch({
                    type:ActionTypes.setModalInfo,
                    data:{
                        title:"Usuario no válido",
                        message:"El usuario no existe o no posee roles en el sistema",
                        type:DialogType.peligro,
                        isVisible:true
                    }
                });
            }

        }).catch(error=>{
            console.log({error});
            if ( error?.response?.status === 400 ){
                dispatch({
                    type:ActionTypes.setModalInfo,
                    data:{
                        title:"Usuario no válido",
                        message:"El usuario no existe o no posee roles en el sistema",
                        type:DialogType.peligro,
                        isVisible:true
                    }
                });
            }

        }).finally(()=>{
            dispatch({
                type:ActionTypes.setLoadingPage,
                data:false
            });
        });



    }

    useEffect(()=>{
       
    },[]);
  
    return (
        <Box
          sx={{
            minHeight: '100dvh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            px: 2,
            py: 4,
            bgcolor: 'background.default',
          }}
        >
             <CustomLogoApp height={72} alt="Acércate" />
             <Typography variant="h6" sx={{ mt: 2, mb: 3, fontWeight: 700 }}>
              Ingresar a Acércate
             </Typography>
          
            <Paper
              component="form"
              elevation={0}
              variant="outlined"
              onSubmit={handleSubmit(onSumitData)}
              sx={{
                width: '100%',
                maxWidth: 400,
                p: 3,
                borderRadius: 3,
              }}
            >
                <TextField
                  fullWidth
                  label="Correo / usuario"
                  type="email"
                  autoComplete="username"
                  error={Boolean(errors.usuario?.message)}
                  helperText={errors.usuario?.message}
                  {...register("usuario")}
                />
                <TextField
                  fullWidth
                  sx={{ mt: 2 }}
                  label="Contraseña"
                  type="password"
                  autoComplete="current-password"
                  error={Boolean(errors.clave?.message)}
                  helperText={errors.clave?.message}
                  {...register("clave")}
                />
                <Button type="submit" fullWidth variant="contained" sx={{ mt: 3 }}>
                  Ingresar
                </Button>
              </Paper>
        </Box>
    )

}
